import tokens from '@change/ds-tokens';

type Result = ModelHookResult<{
	customEditorConfig: Record<string, unknown>;
	blurbEditorConfig: Record<string, unknown>;
}>;

// eslint-disable-next-line max-lines-per-function
export function useEditorConfig(): Result {
	return {
		data: {
			customEditorConfig: {
				minHeight: 250,
				menubar: false,
				plugins: 'link paste lists emoticons template',
				toolbar: 'bold italic underline fontsize forecolor backcolor | link | bullist emoticons template',
				branding: false,
				inline_boundaries: false,
				resize: true,
				statusbar: false,
				link_title: false,
				paste_as_text: true,
				convert_urls: false,
				relative_urls: false,
				target_list: [{ title: 'New page', value: '_blank' }],
				font_size_formats: '13px 16px 18px 20px 25px',
				color_map: [
					// Brand & accent strong
					tokens.colors.semantic.light.fill['brand strong'], // #f34e49 (color-fill-brand-strong)
					'Change.org Red Brand - #f34e49',
					tokens.colors.semantic.light.fill['accent primary strong'], // #0d4dfb (color-fill-accent-primary-strong)
					'Accent Primary Strong - #0d4dfb',
					tokens.colors.semantic.light.fill['accent secondary strong'], // #ab0eff (color-fill-accent-secondary-strong)
					'Accent Secondary Strong - #ab0eff',
					tokens.colors.semantic.light.fill.interactive, // #ffdb00 (color-fill-interactive)
					'Interactive - #ffdb00',

					// Accent primary / secondary weak & weaker
					tokens.colors.semantic.light.fill['accent primary weak'], // #cddbff (color-fill-accent-primary-weak)
					'Accent Primary Weak - #cddbff',
					tokens.colors.semantic.light.fill['accent primary weaker'], // #f0f7ff (color-fill-accent-primary-weaker)
					'Accent Primary Weaker - #f0f7ff',
					tokens.colors.semantic.light.fill['accent secondary weak'], // #e9c1ff (color-fill-accent-secondary-weak)
					'Accent Secondary Weak - #e9c1ff',
					tokens.colors.semantic.light.fill['accent secondary weaker'], // #fbf3ff (color-fill-accent-secondary-weaker)
					'Accent Secondary Weaker - #fbf3ff',

					// Backgrounds & fills (grays)
					tokens.colors.semantic.light.background.base, // #ffffff (color-background-base)
					'White - #ffffff',
					tokens.colors.semantic.light.background.raised, // #f8f9fd (color-background-raised)
					'Background Raised - #f8f9fd',
					tokens.colors.semantic.light.background.overlay, // #f1f3f8 (color-background-overlay)
					'Background Overlay - #f1f3f8',
					tokens.colors.semantic.light.fill.weaker, // #3a3e491a (color-fill-weaker)
					'Fill Weaker - #3a3e491a',
					tokens.colors.semantic.light.fill.weak, // #3a3e49cc (color-fill-weak)
					'Fill Weak - #3a3e49cc',
					'#000000', // pure black (no DS token)
					'Black - #000000',

					// Typography
					tokens.colors.semantic.light.typography.strong, // #2d2f37 (color-typography-strong)
					'Typography Strong - #2d2f37',
					tokens.colors.semantic.light.typography.weak, // #3a3e49cc (color-typography-weak)
					'Typography Weak - #3a3e49cc',
					tokens.colors.semantic.light.typography.disabled, // #3a3e4966 (color-typography-disabled)
					'Typography Disabled - #3a3e4966',
					tokens.colors.semantic.light.typography.brand, // #bc1e19 (color-typography-brand)
					'Typography Brand - #bc1e19',
					tokens.colors.semantic.light.typography.error, // #910a21 (color-typography-error)
					'Typography Error - #910a21',
					tokens.colors.semantic.light.typography.warning, // #7e3b10 (color-typography-warning)
					'Typography Warning - #7e3b10',
					tokens.colors.semantic.light.typography.success, // #075208 (color-typography-success)
					'Typography Success - #075208',
					tokens.colors.semantic.light.typography.information, // #003193 (color-typography-information)
					'Typography Information - #003193',
					tokens.colors.semantic.light.typography['accent secondary'], // #5b038b (color-typography-accent-secondary)
					'Typography Accent Secondary - #5b038b',
				],
				color_cols: 8,
				templates: [
					{
						title: '{{user_preferred_name}}',
						description: 'User Preferred Name',
						content: '{{user_preferred_name}}',
					},
				],
			},
			blurbEditorConfig: {
				content_style: 'body { font-size: 20px; }',
			},
		},
	};
}
